export default {
    init() {
      // JavaScript to be fired on the dta certificate page
  
    },
    finalize(){
        $("#downloadKTCertificate").on("click", function(){
            const pdf_url = $('#certificate').data('cert-url');
            const file_name = pdf_url.split("/").pop().replace('.pdf', '');
            const pdf_link = document.createElement('a');
            pdf_link.href = pdf_url;
            pdf_link.download = file_name;
            pdf_link.target = "_blank";
            pdf_link.click();
        })

        $(window).bind('unload', function(e){
          const preview_image_id = $('#certificate').data('preview-image-id');
          $.ajax({
            type: "POST",
            url: ajaxdta.ajaxurl + "?action=remove_preview_image",
            data: {
                preview_image_id,
            },
            data_type: 'JSON'
          });
        })
    }
  };


// WEBPACK FOOTER //
// ./scripts/routes/kt-certificate.js